import { useFieldContext } from '@zealth/core/form/contexts'
import type { NumberFormFieldProps } from '@zealth/core/formFields/types'

import { SpinnerField } from '@/ui'

export const NumberFormField = ({
  label,
  placeholder,
  optional,
  min,
  max,
}: NumberFormFieldProps) => {
  const field = useFieldContext<number | null>()

  const value = field.state.value ?? null

  const handleChange = (value: number | null) => {
    field.handleChange(value)
  }

  return (
    <SpinnerField
      format={{
        useGrouping: false,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }}
      fullWidth
      required={!optional}
      label={label}
      placeholder={placeholder}
      min={min}
      max={max}
      value={value}
      error={field.state.meta.errors.length > 0}
      helperText={field.state.meta.errors[0]?.message ?? ' '}
      onBlur={field.handleBlur}
      onValueChange={handleChange}
    />
  )
}
